import React, { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { taskTypes } from "../../../common/parameters";

import Modal from "../Modal";
import Form, { Title } from "../Form";

import { IProps } from "./interfaces";
import messages from "./messages";

const TaskDescriptionModal = ({ task }: IProps) => {
    const { formatMessage } = useIntl();
    const [isOpen, setIsOpen] = useState(true);
    const { description, type } = task;
    const handleClose = () => {
        setIsOpen(false);
    }
    if (!description || !isOpen) return null;
    return (
        <Modal close={handleClose}>
            <Title>{taskTypes(formatMessage)[type]}</Title>
            <Form>
                <p dangerouslySetInnerHTML={{ __html: description.replace("\n", "<br/>") }} />
                <button onClick={handleClose} className="button button--full-width">
                    <FormattedMessage {...messages.close} />
                </button>
            </Form>
        </Modal>
    );
}

export default TaskDescriptionModal;
